import { useHistory } from 'react-router-dom';
import { Button, Page, PageTitleWithButton } from '../../../components';
import { ClientsList } from './clients-list';
import { Add } from '@mui/icons-material';
import { useMediaQuery } from '@mui/material';

export const ClientsPage = () => {
  const history = useHistory();
  const removeStickyHeader = useMediaQuery('(max-width: 1012px)');
  return (
    <Page pageHasStickyHeaders={removeStickyHeader ? false : true} title="Manage Purchasers">
      <PageTitleWithButton
        pageTitleProps={{
          title: 'Manage Purchasers'
        }}
        button={
          <Button
            id="create-client"
            onClick={() => {
              history.push('/sales/contracting/purchasers/add');
            }}
            color="primary"
            variant="contained"
            startIcon={<Add />}
          >
            Create Purchaser
          </Button>
        }
      />
      <ClientsList />
    </Page>
  );
};
